import { useObservableState } from 'observable-hooks';
import facade from 'context/OrganisationContext/facade';
import { type Characteristic, type OrganisationEmissionResult } from 'types/models';
import { OrganisationType } from 'utils/enum';
import { type FacadeReturnTypes, getObservableProp, type NullablePartial } from 'utils/modules/state';

interface OrganisationContextFacade extends FacadeReturnTypes<typeof facade> {
   error: any;
   isLoading: boolean;
   context: any;
   results: OrganisationEmissionResult[];
   orgCharacteristics: Characteristic[];
}

const defaults: NullablePartial<OrganisationContextFacade> = {
   isLoading: true,
   theme: null,
   activeOrganisationId: null,
   topLevelOrganisationId: null,
   characteristics: [],
   consolidationMethod: 'FULL',
   currency: null,
   currencyCode: null,
   customization: null,
   organisationId: null,
   parentIds: [],
   parents: [],
   reportingStandards: [],
   results: [],
   subsidiaries: [],
   subsidiaryIds: [],
   type: OrganisationType.ORGANIZATION,
   allowDataEntry: true,
   orgCharacteristics: [],
   isOrganisationActive: true,
   minValidFrom: undefined,
   maxValidTo: undefined,
};

export default function useOrganisationContext() {
   return {
      state: new Proxy<OrganisationContextFacade>({} as OrganisationContextFacade, {
         get: (target, prop: keyof OrganisationContextFacade) => {
            if (prop === 'error') {
               // eslint-disable-next-line react-hooks/rules-of-hooks
               return useObservableState(facade.query.selectError());
            }
            if (prop === 'isLoading') {
               // eslint-disable-next-line react-hooks/rules-of-hooks
               return useObservableState(facade.loading$, defaults[prop]);
            }
            if (prop === 'context') {
               // eslint-disable-next-line react-hooks/rules-of-hooks
               return useObservableState(facade.reducedContext$);
            }

            return getObservableProp(facade, defaults, prop);
         },
      }),
      setActiveOrganisation: facade.api.setActiveOrganisation,
   };
}
